// extracted by mini-css-extract-plugin
export default {"mag_home_management_container":"components_mag_home_management_container__5h0lX","header_area":"components_header_area__-3p8L","mag_home_tabs":"components_mag_home_tabs__JdeS7"};